import FooterLogo from './images/footer-logo.png';
import VisaLogo from './images/visa-logo.png';
import MasterLogo from './images/master-logo.png';
import './Footer.css';
function Footer() {
return(
    <footer className="footer">
        {/* <img src={VisaLogo} /> */}
        <div className='top-footer'>
            <div className='container'>
                <div className='row'>
                    <div className='col-md-4'>
                        <img className='footerlogo' src={FooterLogo} />
                        <p><strong>Legal Entity Identifier India Limited </strong>(CIN- U74900MH2015PLC268921)</p>
                    </div>
                    <div className='col-md-4'>
                        <h2 className='heading2'>OTHER SERVICES</h2>
                        <ul>
                            <li><a href='#'>About us</a></li>
                            <li><a href='#'>Events</a></li>
                            <li><a href='#'>Download invoice & LEI</a></li>
                            <li><a href='#'>Certificate</a></li>
                            <li><a href='#'>Rules for LOU Services</a></li>
                            <li><a href='#'>Rules for LOU Services</a></li>
                            <li><a href='#'>Privacy policy</a></li>
                            <li><a href='#'>Cookie statement</a></li>
                            <li><a href='#'>Announcements</a></li>
                        </ul>
                    </div>
                    <div className='col-md-4'>
                    <div className='footer-Search'>
                        <form>
                            <input type="text" placeholder='Search for a company or LEI code' name="name" />
                            <button><i class="fas fa-search"></i> Search</button>
                        </form>
                    </div>
                    <div className='footer-payment'>
                        <ul>
                            <li><img src={VisaLogo} /></li>
                            <li><img src={MasterLogo} /></li>
                        </ul>
                    </div>                        
                    </div>
                </div>
            </div>
        </div>  
        <div className='bottom-footer'>
            <div className='container'>
                <div className='row'>
                    <div className='col-md-6'>
                        <p>Copyright© 2023 Legal Entity Identifier India Limited, All rights reserved	</p>
                    </div>
                    <div className='col-md-6 text-right'>
                        <p>Designed & Maintained by Cyfuture</p>
                    </div>
                </div>
            </div>
        </div>
        <div className='live-chat'>Chat Now <i class="far fa-comment"></i></div>
    </footer>
)
}
export default Footer